<template>
	<div class="menu-notification py-3 d-flex gap-3 align-items-center" :data-notification-id="data.notification_id">
		<div class="notification-text d-flex flex-column justify-content-between flex-grow-1">
			<div class="d-flex gap-2">

				<div class="d-flex gap-2 align-items-center">
					<div class="thumb" :style="`background: url(${getIcon()});`"></div>
					<div class="d-flex">
						<span class="author">{{ category }} <span class="description">{{ getText() }}</span></span>
					</div>
				</div>

			</div>
		</div>
		<div class="notifications-actions">
			<div ref="actions_dropdown" class="ui right pointing suidropdown icon button">
				<i class="ellipsis vertical icon"></i>
				<div class="menu">
					<div v-if="!is_friend" class="item" @click="handleFriend('accept', friend_id)">{{ $i18n.t('notification.accept_friend') }}</div>
					<div v-if="!is_friend" id="rejectFriend" class="item">{{ $i18n.t('notification.reject_friend') }}</div>
					<!-- <div v-if="is_friend" class="item" @click="markAsReed">{{ $i18n.t('notification.delete') }}</div> -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from "vuex";  // mapActions
export default {
	name: "FriendRequest",
	props: {
		data		: [],
		icon		: { type: String, default: '' },
		category	: { type: String, default: '' },
		// title	: { type: String, default: '' },
		// text		: { type: String, default: '' },
		// createdAt: { type: String, default: '' },
		// flag		: { type: String, default: '' },
		// type		: { type: String, default: '' },
	},
	data() {
		return {
			notificationId	: 0,
			is_pending		: false,
			is_friend		: false,
			// is_reject		: false,
			friendNickname	: '',
			friend_id		: -1
		}
	},
	computed: {
        ...mapGetters([
            'logged', 'token'
        ]),
    },
	beforeMount() {
		let vm              = this;
		vm.notificationId   = vm.data.notification_id ?? vm.data.object.notification_id;
		// vm.friendNickname = vm.data.nickname ?? vm.data.object.nickname;
		vm.is_pending 		= vm.data.is_pending;
		vm.is_friend 		= vm.data.is_friend;
		// vm.is_reject 		= !vm.data.is_pending && !vm.data.is_friend;
		vm.friend_id 		= vm.data.friend_id ?? vm.data.object.friend_id;

		// console.log('FReque =>', this.data);
	},
	mounted() {
		window.$(this.$refs.actions_dropdown).suidropdown({
			// transition: 'drop'
		});

		// feito aqui pois o 'confirm' do browser dá conflito com o fomantic
		document.getElementById('rejectFriend').addEventListener('click', (event) => {
			event.stopPropagation();
			if( window.confirm(this.$i18n.t('notification.reject_friend_confirm')) ) {
				window.$(this.$refs.actions_dropdown).suidropdown('hide');
				this.handleFriend('reject', this.friend_id);
			}
		});
	},
	methods: {
		getIcon() {
			if( this.data.is_group && this.data.object.thumbnail) {
				return this.data.object.thumbnail;
			}
			return this.data.icon;
		},
		getText() {
			if( this.data.text ) {
				return this.data.text.replace(this.data.nickname, "");
			}
			return '';
		},
		markAsReed() {
            let vm          = this;
            let headers     = { 'Content-Type': 'application/json;charset=UTF-8', 'Access': 'application/json', language: vm.$i18n.locale, Authorization : `Bearer ${vm.token}`};
            let form_data   = new FormData();
            // vm.$app.wait(true);
            window.$(vm.$refs.actions_dropdown).addClass('loading');
            form_data.append('notification', vm.notificationId);
			form_data.append('no_timestamp', true);
            axios.post(vm.$url_api + 'api/ReedNotification', form_data, { headers:headers })
                .then(response => {
                    response;
                    vm.removeNotification();
                })
                .catch(error => {
                    console.log('error', error.response.data)
                })
                .finally(response => {
                    response;
                    // vm.$app.wait(false);
                    window.$(vm.$refs.actions_dropdown).removeClass('loading');
                });
        },
		removeNotification() {
			// 1 - find the index of the notification with the matching ID
			const index = this.$app.notification_list.findIndex(notification => notification.notification_id === this.notificationId);
			// 2 - if found, remove it from the array
			if( index !== -1 ) { this.$app.notification_list.splice(index, 1); }
		},
		handleFriend(action, id) {
			console.log(action, id);
			let vm		= this;
			let payload = {
				"friend_id": id,
			}
			// vm.$app.wait(true);
			window.$(vm.$refs.actions_dropdown).addClass('loading');
			switch( action ) {
				case 'accept':
					vm.$store.dispatch('Friends/AcceptRequest', payload)
						.then(response => {
							response;
							vm.is_pending 	= false;
							vm.is_friend 	= true;
							// vm.is_reject	= false;
							// vm.$app.wait(false);
							vm.removeNotification();
						})
						.catch(error => {
							console.log('error', error.response.data)
						})
						.finally(response => {
							response;
							// vm.$app.wait(false);
							window.$(vm.$refs.actions_dropdown).removeClass('loading');
						});
					break;
				case 'reject':
					// if( window.confirm('Tem certeza que deseja rejeitar o pedido de amizade?') ) {
					// console.log('CONFIRMADO REJEICAO');
					vm.$store.dispatch('Friends/RejectRequest', payload)
						.then(response => {
							response;
							vm.is_pending 	= false;
							vm.is_friend 	= false;
							// vm.is_reject	= true;
							vm.removeNotification();
						})
						.catch(error => {
							console.log('error', error.response.data)
						})
						.finally(response => {
							response;
							// vm.$app.wait(false);
							window.$(vm.$refs.actions_dropdown).removeClass('loading');
						});
					//}
					break;
			}

			// Friends/RemoveFriend
			// Friends/BlockUser
			// Friends/UnblockUser
		}
		/*
		getIcon() {
			let icon = "";
			if (this.is_friend)			{ icon = "how_to_reg"; }
			else if (this.is_pending)	{ icon = "group_add"; }
			else if (this.is_reject)	{ icon = "group_off"; }
			return icon;
		},
		*/
	}
}
</script>

<style scoped lang="scss">
	.menu-notification {
		flex-grow: 1;
		position: relative;
		// cursor: default;

		.done {
			cursor: pointer;
			color: var(--buttons_color);
			font-size: 25px;
			position: relative;

			&:before {
				content: "";
				position: absolute;
				top: -10px;
				bottom: -10px;
				left: -10px;
				right: -10px;
			}
		}

		.notification-icon {
			width: 140px;
			height: 89px;
			flex-shrink: 0;
			border-radius: 10px;
			background: #F6F6F6;


		}

		.notification-text {


			.title {
				color: var(--buttons_color);
				font-family: "Hanken Grotesk", sans-serif;
				font-size: 16px;
				font-style: normal;
				font-weight: 700;
				line-height: normal;
				display: flex;
				align-items: center;

			}

			.author {
				font-family: "Open Sans", sans-serif;
				font-size: 1rem;
				font-weight: 600;
				line-height: 19px;
				color: var(--buttons_color) !important;
				margin-left: 5px !important;
			}

			.description {
				font-family: "Open Sans", sans-serif;
				font-weight: 400;
				font-size: 0.95rem !important;
				line-height: 19px;
				color: #393939 !important;
			}

			.thumb {
				width: 48px;
				height: 48px;
				border-radius: 100%;
				position: relative;
				background-size: cover !important;
				background-position: center !important;
				background-repeat: no-repeat !important;
				background-blend-mode: saturation;
				flex-shrink: 0;
			}

			.icon-container {
				width: 49px;
				height: 49px;
				flex-shrink: 0;
				border-radius: 54px;
				position: relative;
				background-color: #F0F0F0;

				.material-symbols-outlined {
					color: #FFFFFF !important;
				}

			}

		}

		&.pendent {
			background-color: #00C4FF1F;

			&:hover {
				background-color: #F9F9F9;
			}
		}

		&.viewed {
			background-color: #FFFFFF;


			&:hover {
				background-color: #F9F9F9;
			}
		}

		&.new-notification {
			background-color: pink;
		}

		.material-symbols-outlined {
			font-variation-settings:
				'FILL' 1,
				'wght' 400,
				'GRAD' 0,
				'opsz' 24
		}

		.notifications-actions{
            position:absolute;
            top: 3px;
            right: 2px;
            line-height: 0;
            .ui.suidropdown{
                padding: 0px !important;
                background: none;
                margin: 0 !important;
                .icon{
                    color: #b5b5b5;
                }
            }

            .ui.right.pointing.suidropdown > .menu{
                margin: 0px;
                &::after{
                    display: none;
                }
                .item{
                    font-size: 12px;
                }
            }
            
        }

	}
</style>